<div style="padding:24px 32px 0">
    <app-lun-group-base-info
        [item]="data"
    ></app-lun-group-base-info>
    <!-- 微存储不支持性能监控-->
    <app-base-performace-chart [id]="data.actionParams" [performance]="[22,21,370]" type="LUN_GROUP" *ngIf="!FeatureConfig.IsHidePms"></app-base-performace-chart>
    <app-lun-group-resource [data]="data"></app-lun-group-resource>
</div>
